export { default } from './AktivasiMyPertamina';
